import { AbcdeRiskValue } from "../schema";

/**
 * If an MVAR is greater than or equal to a threshold, it qualifies for it.
 * Maximum threshold wins.
 */
export const riskValueThresholds: Record<AbcdeRiskValue, number> = {
  A: 0,
  B: 0.002,
  C: 0.01,
  D: 0.02,
  E: 0.05,
};
